import { LockOutlined } from "@ant-design/icons";
import { Form, Input, Typography } from "antd";

import { AUTH_COPY, AUTH_PLACEHOLDERS } from "@/constants";
import { validatePasswordValue } from "@/utils/auth-account";

const { Text } = Typography;

interface PasswordFormItemProps {
  name?: string;
  label?: string;
  autoComplete?: string;
  helperText?: string;
  placeholder?: string;
  validateStrength?: boolean;
}

export const PasswordFormItem = ({
  name = "password",
  label = "Mật khẩu",
  autoComplete = "current-password",
  helperText,
  placeholder = AUTH_PLACEHOLDERS.password,
  validateStrength = true,
}: PasswordFormItemProps) => (
  <Form.Item
    extra={helperText ? <Text type="secondary">{helperText}</Text> : undefined}
    label={label}
    name={name}
    rules={[
      {
        validator: async (_, value: string | undefined) => {
          const error = validateStrength
            ? validatePasswordValue(value ?? "")
            : !value?.trim()
              ? "Vui lòng nhập mật khẩu."
              : null;

          if (error) {
            throw new Error(error);
          }
        },
      },
    ]}
  >
    <Input.Password
      autoComplete={autoComplete}
      prefix={<LockOutlined />}
      placeholder={placeholder}
    />
  </Form.Item>
);

export const defaultPasswordHelperText = AUTH_COPY.passwordHint;
